import { useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { getPendingUsers } from '../../actions/pending.users';
import styles from './PendingUsers.module.css';

const PendingUsers = (props) => {
  const { 
    getPendingUsers, 
    pendingUsersData,
  } = props;

  useEffect(() => {
    getPendingUsers();
  }, []);

  const exportToCSV = () => {
    if (!pendingUsersData || pendingUsersData.length === 0) return;
    
    const headers = ['Id', 'Name', 'Email', 'Created At', 'Onboarded At'];
    
    const rows = pendingUsersData.map(user => [
      user.id,
      user.name,
      user.email,
      user.created_at ? new Date(user.created_at).toLocaleString() : '',
      user.onboarded_at ? new Date(user.onboarded_at).toLocaleString() : '',
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `pending_users_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="wrapper">
      <div className={styles.tools}>
        <h1>
          Pending Users
        </h1>
        <div className={styles.buttons}>
          <div className={styles.exportButton} onClick={exportToCSV}>
            Export CSV
          </div>
        </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Email</th>
            <th>Created At</th>
            <th>Onboarded at</th>
          </tr>
        </thead>
        <tbody>
          {pendingUsersData?.map((user) => (
            <tr key={user.id}>
              <td>
                {user.id}
              </td>
              <td>
                {user.name}
              </td>
              <td>
                {user.email}
              </td>
              <td>
                {user.created_at ? new Date(user.created_at).toLocaleString() : '-'}
              </td>
              <td>
                {user.onboarded_at ? new Date(user.onboarded_at).toLocaleString() : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  pendingUsersData: store.pendingUsers.pendingUsersData,
});

const mapDispatchToProps = {
  getPendingUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingUsers);
